import { render, staticRenderFns } from "./CompanyNews_details.vue?vue&type=template&id=73f03d54&scoped=true"
import script from "./CompanyNews_details.vue?vue&type=script&lang=js"
export * from "./CompanyNews_details.vue?vue&type=script&lang=js"
import style0 from "./CompanyNews_details.vue?vue&type=style&index=0&id=73f03d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f03d54",
  null
  
)

export default component.exports